<template>
    <div class="row col-12 mx-auto">
        <page-title :title="$t('annualCatalog.annualCatalog')" :showTitle="false"></page-title>
        <div v-if="loading" class="loader"></div>
        <div class="card" v-if="!loading">
            <div class="card col-12 mx-auto mt-2 px-0">
                <div class="card-header bg-primary text-white">
                    <div class="h5">
                        {{ $t('annualCatalog.annualCatalog') }} - {{ annualCatalog.year }},
                        {{ $t('annualCatalog.approved') }}: {{ annualCatalog.approvedUser }}
                        {{ $t('annualCatalog.on') }}
                        {{
                        `${annualCatalog.createdDate.getDate()}.${annualCatalog.createdDate.getMonth() +
                        1}.${annualCatalog.createdDate.getFullYear()}`
                        }}
                    </div>
                </div>

                <div class="card-body">
                    <div v-if="annualCatalog">
                        <kendo-datasource :schema-model-fields="schemaModelFields">
                        </kendo-datasource>
                        <kendo-grid ref="grid"
                                    :sortable="true"
                                    :filterable="true"
                                    :data-source="annualCatalog.items"
                                    :toolbar="toolbar"
                                    :excel="gridOptions.excel"
                                    :pdf="gridOptions.pdf">
                            <kendo-grid-column :field="'theme'"
                                               :title="$t('planning.theme')">
                            </kendo-grid-column>
                            <kendo-grid-column :field="'thematicArea'"
                                               :title="$t('thematicArea.thematicArea')">
                            </kendo-grid-column>
                            <kendo-grid-column :field="'legalArea'"
                                               :title="$t('planning.legalArea')">
                            </kendo-grid-column>
                            <kendo-grid-column :template="lectorTemplate"
                                               :title="$t('planning.lectorsProposal')">
                            </kendo-grid-column>
                            <kendo-grid-column :template="btnsTemplate"
                                               field="btnsColumn"
                                               :title="$t('actions')">
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PageTitle from '../../components/common/PageTitle';
    import { AnnualCatalogModel } from "../../models/models";
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import LectorsTemplate from "./LectorsTemplate";
    import JSZip from 'jszip'

    kendo.pdf.defineFont({
        "DejaVu Sans": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf",
        "DejaVu Sans|Bold": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
        "DejaVu Sans|Bold|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "DejaVu Sans|Italic": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
        "WebComponentsIcons": "https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf"
    });

    export default {
        components: {
            PageTitle,
        },
        data() {
            return {
                searchQuery: '',
                schemaModelFields: {
                    legalArea: {
                        name: 'legalArea',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'planning.legalArea'
                    },
                    theme: {
                        name: 'theme',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'planning.theme'
                    },
                    thematicArea: {
                        name: 'thematicArea',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'planning.thematicArea'
                    },
                    lectors: {
                        name: 'lectors',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'planning.lectorsProposal'
                    }
                },
                annualCatalog: null,
                annualId: '',
                loading: true,
                gridOptions: {
                    excel: {
                        fileName: 'AnnualCatalogDetails.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true,
                    },
                    pdf: {
                        fileName: 'AnnualCatalogDetails.pdf',
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        margin: {
                            top: '2cm',
                            left: '1cm',
                            right: '1cm',
                            bottom: '1cm'
                        },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                }
            }
        },
        created: function () {
            window.JSZip = JSZip // ���������� � �� �� ������ �������� � excel
        },
        methods: {
            loadData() {
                this.$http.get(`/api/AnnualCatalog/GetById/${this.annualId}`).then(result => {
                    if (result) {
                        this.annualCatalog = new AnnualCatalogModel(result.data);
                    }
                    this.loading = false;
                }).catch(error => {
                    // TODO:
                });
            },
            createEvent(args) {
                if (!this.hasEventCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push({
                    name: 'events',
                    params: { annualCatalogItemId: args.id }
                });
            },
            lectorTemplate: function (e) {
                return {
                    template: Vue.component(LectorsTemplate.name, LectorsTemplate),
                    templateArgs: {
                        ...e,
                    }
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [
                            {
                                name: "edit",
                                text: "",
                                tooltip: this.$t('buttons.create.tooltipEvent'),
                                class: 'btn btn-success',
                                icon: "fas fa-plus",
                                show: this.hasEventCreateRights,
                                clickHandler: this.createEvent
                            }
                        ]
                    }
                };
            }
        },
        mounted() {
            this.annualId = this.$route.params.id;
            this.loadData();
        },
        computed: {
            toolbar: function () {
                return [
                    {
                        name: 'excel',
                        text: this.$t('buttons.excelExport.tooltipText')
                    }
                ];
            },
            hasEventCreateRights() {
                return this.$store.getters.claims.event.create;
            }
        }
    }
</script>

<style>
    .k-pdf-export colgroup > col:nth-child(5) {
        width: 0px !important;
    }
</style>

